import numeral from 'numeral';

export const penceToPounds = (value: number): string => {
  return numeral(value / 100).format('0,0.00');
};

export const poundsToPence = (value: number): number => {
  return Math.round(value * 100);
};
